module.exports = __webpack_public_path__ + "static/tree-0629c5bb41986e818b074c66c35b1d6c.svg";